module.exports = __webpack_public_path__ + "static/media/rap_battle_oh.e3208213.gif";